module.exports = __webpack_public_path__ + "static/media/34import-68.01922f90.xlsx";